export const useLocalStorage = () => {
  const saveLocalStorage = (key: string, data: unknown) => {
    const tokenString = JSON.stringify(data);
    return localStorage.setItem(key, tokenString);
  };

  const getLocalStorage = (key: string) => {
    const data = localStorage.getItem(key);
    try {
      if (data) {
        return JSON.parse(data);
      }
    } catch {
      return null;
    }
  };

  const removeLocalStorage = (key: string) => {
    localStorage.removeItem(key);
  };

  return { saveLocalStorage, getLocalStorage, removeLocalStorage };
};
